import React from 'react';

// Skeleton loader for text content
export const TextSkeleton = ({ lines = 3, className = '' }) => (
  <div className={`skeleton-container ${className}`}>
    {Array.from({ length: lines }).map((_, index) => (
      <div
        key={index}
        className="skeleton-line"
        style={{
          width: index === lines - 1 ? '70%' : '100%',
          animationDelay: `${index * 0.1}s`
        }}
      />
    ))}
  </div>
);

// Skeleton loader for images
export const ImageSkeleton = ({ width = '100%', height = '200px', className = '' }) => (
  <div 
    className={`skeleton-image ${className}`}
    style={{ width, height }}
  />
);

// Card skeleton loader
export const CardSkeleton = ({ className = '' }) => (
  <div className={`skeleton-card ${className}`}>
    <ImageSkeleton height="160px" />
    <div className="skeleton-card-content">
      <div className="skeleton-line" style={{ width: '80%', height: '20px' }} />
      <TextSkeleton lines={2} />
    </div>
  </div>
);

// Spinner loader
export const Spinner = ({ size = 'medium', color = 'primary' }) => {
  const sizeClasses = {
    small: 'spinner-small',
    medium: 'spinner-medium',
    large: 'spinner-large'
  };

  return (
    <div className={`spinner ${sizeClasses[size]} spinner-${color}`}>
      <div className="spinner-inner" />
    </div>
  );
};

// Page loader overlay
export const PageLoader = ({ isVisible, children }) => {
  if (!isVisible) return children;

  return (
    <div className="page-loader-overlay">
      <div className="page-loader-content">
        <Spinner size="large" />
        <p className="page-loader-text">جاري التحميل...</p>
      </div>
    </div>
  );
};

// Fade in animation wrapper
export const FadeInWrapper = ({ children, delay = 0, duration = 0.6, className = '' }) => (
  <div 
    className={`fade-in-wrapper ${className}`}
    style={{
      '--animation-delay': `${delay}s`,
      '--animation-duration': `${duration}s`
    }}
  >
    {children}
  </div>
);

// Slide up animation wrapper
export const SlideUpWrapper = ({ children, delay = 0, className = '' }) => (
  <div 
    className={`slide-up-wrapper ${className}`}
    style={{ '--animation-delay': `${delay}s` }}
  >
    {children}
  </div>
);

// Pulse animation for buttons and interactive elements
export const PulseWrapper = ({ children, className = '' }) => (
  <div className={`pulse-wrapper ${className}`}>
    {children}
  </div>
);